import { Component, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgbDate, NgbDateStruct, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { CompanyParamsService } from '../../../core/services/company-params.service';

import moment from 'moment';

@Component({
    selector: 'app-range-individual-calendar',
    templateUrl: './range-individual-calendar.component.html',
    styleUrls: ['./range-individual-calendar.component.scss'],
    imports: [ReactiveFormsModule, NgbInputDatepicker]
})
export class RangeIndividualCalendarComponent {

  @Input() from!: Date;
  @Input() to!: Date;
  @Input() horizontal: boolean = false;

  @ViewChild("df", { static: true }) df!: NgbInputDatepicker;
  @ViewChild("dt", { static: true }) dt!: NgbInputDatepicker;
  formCalendar: FormGroup = this.formBuilder.group({});

  minDate!: NgbDate;
  maxDate!: NgbDate;
  minDateTo!: NgbDate;
  navigation = 'arrows';
  secondaryCompanyColor = this.companyParamsService.getSecundaryColor();

  @Output() rangeDateSelected: EventEmitter<{ from: any, to: any }> = new EventEmitter();

  disabledRanges: { start: NgbDate, end: NgbDate }[] | undefined = this.companyParamsService.getFiltersSearchCalendarRanges();


  constructor(
    private formBuilder: FormBuilder,
    private cdRef: ChangeDetectorRef,
    public companyParamsService: CompanyParamsService,
    private elRef: ElementRef
  ) {


  }

  ngOnInit(): void {
    this.buildForm();
    this.minDate = this.minDateTo = this.disabledRanges?.length != 0 ?
      (this.todayInBlockedRanges() == -1 ?
        this.toNgbDate(new Date()) : this.setMinDate(this.disabledRanges![this.todayInBlockedRanges()].end))
      : this.toNgbDate(new Date());
    const maxDateAux = new Date();
    maxDateAux.setFullYear(maxDateAux.getFullYear() + 1);
    this.maxDate = this.toNgbDate(maxDateAux);
    this.elRef.nativeElement.style.setProperty('--sec-company-color', '#' + this.secondaryCompanyColor);
  }


  get dateFrom() {
    return this.formCalendar.get("dateFrom");
  }
  get dateTo() {
    return this.formCalendar.get("dateTo");
  }

  private buildForm() {
    this.formCalendar = this.formBuilder.group({
      dateFrom: this.getYearMonthDayFromDate(this.from),
      dateTo: this.getYearMonthDayFromDate(this.to),

    });
  }

  onDateFromSelect(date: NgbDateStruct) {
    // control when the user choose the same value preloaded
    if (this.from.getTime() === this.toDate(date).getTime()) {
      this.from = new Date();
      this.cdRef.detectChanges();
    }
    this.from = this.toDate(date);

    //increment one day  on fromDate selected to control min toDate
    let minDateToAux: Date = new Date(this.from);
    minDateToAux.setDate(minDateToAux.getDate() + 1);
    this.minDateTo = this.toNgbDate(minDateToAux);

    //set maxDate for ToCalendar
    let maxDateAux = minDateToAux;
    maxDateAux.setFullYear(maxDateAux.getFullYear() + 1);
    this.maxDate = this.toNgbDate(maxDateAux);

    this.adjustFromToDates('from');

    this.to = this.from;
    this.adjustFromToDates('to');
  }

  onDateToSelect(date: NgbDateStruct) {
    // control when the user choose the same value preloaded
    const isSameDate: boolean = this.to.getTime() === this.toDate(date).getTime();
    if (isSameDate) {
      this.to = new Date();
      this.cdRef.detectChanges();
    }
    this.to = this.toDate(date);
    this.adjustFromToDates('to');
    if (!isSameDate) this.rangeDateSelected.emit({ from: this.formattedDateFrom, to: this.formattedDateTo });
  }

  get formattedDateFrom(): string {
    if (!this.from) {
      return `missing start date`;
    }
    const fromFormatted = moment(this.from).format('MMMM D, YYYY');
    return `${fromFormatted}`;
  }

  get formattedDateTo(): string {
    if (!this.to) {
      return `missing start date`;
    }
    const toFormatted = moment(this.to).format('MMMM D, YYYY');
    return `${toFormatted}`;
  }

  getYearMonthDayFromDate(date: Date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // Los meses en JavaScript se cuentan desde 0 (enero) hasta 11 (diciembre)
    const day = date.getDate();

    return { year, month, day };
  }

  // from date  to   string  Result: "September 1, 2023"
  formatDate(date: Date): string {
    const options = { month: 'long', day: 'numeric', year: 'numeric' } as Intl.DateTimeFormatOptions;
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  toNgbDate(date: Date): NgbDate {
    const ngbDate: NgbDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    return ngbDate;
  }

  toDate(dateStruct: NgbDateStruct): Date {
    return dateStruct ? new Date(dateStruct.year, dateStruct.month - 1, dateStruct.day) : new Date();
  }

  adjustFromToDates(source: string) {
    if (this.to <= this.from) {
      this.to = new Date(this.from);
      this.to.setDate(this.from.getDate() + 1)

    }
  }

  isDateDisabled = (date: NgbDate, current: { year: number, month: number } | undefined) => {
    for (const range of this.disabledRanges!) {
      if (date.after(range.start) && date.before(range.end) || date.equals(range.start) || date.equals(range.end)) {
        return true;
      }
    }
    return false;
  };

  setMinDate(minDate: NgbDate): NgbDate {
    let date = new Date(minDate.year, minDate.month - 1, minDate.day);
    date.setDate(date.getDate() + 1);
    this.from = date;
    let newDateTo = new Date(date);
    newDateTo.setMonth(newDateTo.getMonth() + 1);
    this.to = newDateTo;
    let finalDate = this.toNgbDate(date);
    return finalDate;
  }

  todayInBlockedRanges(): number {
    let today = new Date();
    let todayNgb = this.toNgbDate(today);
    let i = -1;

    for (const [index, range] of this.disabledRanges?.entries()!) {
      if (todayNgb.after(range.start) && todayNgb.before(range.end) || todayNgb.equals(range.start) || todayNgb.equals(range.end)) {
        i = index;
        break;
      }
    }
    return i;
  };

}
